module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./DeliveryTmpView.js"));
	}, "DeliveryTmpView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DeliveryTmpView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/DeliveryTmp/DeliveryTmpView.js
// module id = 1533
// module chunks = 418